module.exports = __webpack_public_path__ + "assets/pictograms/private-user.f29accf44672f72c28462735f6460c7b.svg";